import Vue from 'vue'
import Vuetify from 'vuetify'
import colors from 'vuetify/lib/util/colors'
import VueRouter from 'vue-router'
import ja from 'vuetify/src/locale/ja'
import axios from 'axios'
//import 'babel-polyfill'
import Layout from '@/Layout.vue'
import '@/sass/admin.sass'
import routes from '@/routes'
import store from '@/store'

Vue.use(Vuetify)
Vue.use(VueRouter)

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: routes
})

const vuetify = new Vuetify({
  lang: {
    locales: { ja },
    current: 'ja'
  },
  icons: {
    iconfont: 'mdi',
  },
  theme: {
    themes: {
      light: {
        primary: colors.blue.darken4,
        accent: colors.orange.darken4,
        error: colors.red.base,
        secondary: colors.blueGrey.base
      }
    }
  }
})

setTimeout(() => {
  const settingsElement = document.querySelector('meta[name=settings]') as any
  const settings = JSON.parse(settingsElement.content)
  store.dispatch('setSettings', settings)
  new Vue({
    el: '#admin',
    render: h => h(Layout),
    vuetify,
    router,
    store
  })
  setTimeout(() => {
    document.getElementById('app').classList.add('displayed')
  })
}, 1000)

axios.interceptors.request.use(request => {
  const auth = localStorage.getItem('auth')
  if (auth) {
    const tokenElement = document.querySelector('meta[name=csrf-token]') as any
    const authJSON = JSON.parse(auth)
    request.headers.contentType = 'application/json; charset=utf8'
    request.headers.dataType = 'json'
    request.headers['X-CSRF-TOKEN'] = tokenElement ? tokenElement.content : null
    request.headers.client = authJSON['authClient']
    request.headers.uid = authJSON['authUId']
    request.headers['access-token'] = authJSON['authAccessToken']
  } else {
    router.push('/admin/login')
  }
  return request
})

axios.interceptors.response.use(onFulfilled => {
  return onFulfilled
}, error => {
  console.log(error)
  if (error.request?.status === 401) {
    window.location.href = '/admin/login'
  }
  throw error
})
